export default "__VITE_ASSET__B0BNjk1G__"